import { combineReducers } from 'redux';

import sharedReducer from './shared';
import taxRatesReducer from './taxRates';

export default combineReducers({
  shared: sharedReducer,
  taxRates: taxRatesReducer,
});
